module.exports = __webpack_public_path__ + "img/ai.6b9c8277.png";